export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  imagePrompt: string;
  author: string;
  publishedAt: string;
  readTime: number;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
  views: number;
  source: string;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '顶流明星王一凡新剧《星河万里》首播收视率破3，创下今年国产剧最高纪录',
    excerpt: '由王一凡主演的都市情感剧《星河万里》于昨晚正式开播，首集收视率高达3.2%，成为2026年开年以来收视率最高的国产电视剧。',
    content: `<p>由王一凡主演的都市情感剧《星河万里》于昨晚正式开播，首集收视率高达3.2%，成为2026年开年以来收视率最高的国产电视剧。该剧讲述了一位年轻建筑师在城市发展与历史保护之间寻找平衡的故事。</p><p>据知情人士透露，王一凡为了这个角色特意去建筑设计院实习了两个月，力求呈现出最真实的建筑师形象。导演李明辉在接受采访时表示："王一凡的敬业程度超出我的预期，他在片场几乎不需要替身。"</p><p>网友纷纷在社交平台表达对该剧的喜爱，话题#星河万里首播#迅速登上热搜榜首，累计阅读量超过15亿次。不少观众表示剧情紧凑、演员演技在线，期待后续发展。</p><p>业内人士分析，该剧有望成为今年度的现象级作品，王一凡也将凭借此剧进一步巩固其在影视圈的地位。</p>`,
    category: '影视资讯',
    categorySlug: 'film',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20scene%20of%20a%20young%20Chinese%20actor%20standing%20on%20a%20modern%20city%20rooftop%20at%20sunset%2C%20wearing%20a%20stylish%20architect%20outfit%2C%20looking%20confidently%20at%20the%20skyline%2C%20warm%20golden%20lighting%2C%20professional%20cinematic%20photography%20with%20lens%20flare%2C%20clean%20composition%2C%20moody%20atmosphere%2C%20high%20production%20value%20shot&width=800&height=500&seq=article-1-2026-x1&orientation=landscape',
    imagePrompt: 'A dramatic cinematic scene of a young Chinese actor standing on a modern city rooftop at sunset, wearing a stylish architect outfit, looking confidently at the skyline, warm golden lighting, professional cinematic photography with lens flare, clean composition, moody atmosphere, high production value shot',
    author: '娱乐记者小王',
    publishedAt: '2026-07-06',
    readTime: 5,
    isHot: true,
    isNew: false,
    tags: ['王一凡', '星河万里', '收视率', '国产剧'],
    views: 158000,
    source: '新浪娱乐',
  },
  {
    id: 'article-2',
    title: '知名网红陈大美直播带货翻车，被曝销售额数据造假引发全网热议',
    excerpt: '拥有千万粉丝的带货主播陈大美在最新一场直播中被曝出销售额数据严重注水，实际成交额远低于宣传数据。',
    content: `<p>拥有千万粉丝的带货主播陈大美在最新一场直播中被曝出销售额数据严重注水。根据第三方监测平台数据显示，其宣称"单场破亿"的直播实际成交额不足3000万，数据注水比例超过200%。</p><p>事件曝光后，陈大美团队发布声明称数据差异是由于"统计口径不同"导致，但这一解释并未获得网友认可。多位消费者在评论区表示在直播间购买的商品与宣传严重不符。</p><p>直播带货行业数据造假问题由来已久，此前已有多位头部主播因类似问题受到质疑。业内专家呼吁建立更严格的直播带货监管机制，保护消费者权益。</p><p>截至目前，相关话题#陈大美数据造假#已在微博获得超过8亿阅读量，多个品牌方表示将暂停与其合作。</p>`,
    category: '网红动态',
    categorySlug: 'influencer',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20social%20media%20influencer%20live%20streaming%20studio%20setup%20with%20bright%20ring%20lights%20and%20products%20displayed%20on%20a%20table%2C%20the%20influencer%20showing%20a%20cosmetic%20product%20to%20camera%2C%20modern%20streaming%20equipment%2C%20slightly%20chaotic%20behind%20the%20scenes%20vibe%2C%20warm%20studio%20lighting%2C%20professional%20lifestyle%20photography&width=800&height=500&seq=article-2-2026-x2&orientation=landscape',
    imagePrompt: 'A social media influencer live streaming studio setup with bright ring lights and products displayed on a table, the influencer showing a cosmetic product to camera, modern streaming equipment, slightly chaotic behind the scenes vibe, warm studio lighting, professional lifestyle photography',
    author: '深度调查记者老张',
    publishedAt: '2026-07-05',
    readTime: 6,
    isHot: true,
    isNew: false,
    tags: ['陈大美', '直播带货', '数据造假', '网红经济'],
    views: 232000,
    source: '腾讯新闻',
  },
  {
    id: 'article-3',
    title: '《歌手2026》总决赛精彩回顾：黑马选手林小宇逆袭夺冠，全场沸腾',
    excerpt: '备受瞩目的音乐竞技节目《歌手2026》总决赛昨晚落幕，赛前不被看好的新人林小宇凭借一首原创歌曲惊艳全场。',
    content: `<p>备受瞩目的音乐竞技节目《歌手2026》总决赛昨晚在国家体育馆落下帷幕。赛前不被看好的新人选手林小宇凭借一首原创歌曲《追光者》惊艳全场，最终以压倒性优势夺得本季冠军。</p><p>林小宇在赛后采访中激动落泪，表示："这个冠军来之不易，感谢一路支持我的歌迷和节目组给予的机会。"他的原创歌曲《追光者》在节目播出后仅两小时内便登顶各大音乐平台榜单。</p><p>节目制作人透露，本季《歌手2026》的平均收视率达到3.5%，总决赛更是突破5%，创下该系列节目的新高。多位乐评人对林小宇的表现给予高度评价，认为他是今年华语乐坛"最值得关注的新人"。</p><p>据悉，林小宇已收到多家唱片公司的签约邀请，其首张个人专辑预计将于年内发布。</p>`,
    category: '综艺热点',
    categorySlug: 'variety',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20singer%20performing%20on%20a%20grand%20stage%20with%20dramatic%20stage%20lighting%20and%20confetti%20falling%2C%20holding%20a%20microphone%20with%20passion%2C%20large%20audience%20cheering%20in%20the%20background%2C%20concert%20photography%20style%2C%20warm%20spotlight%2C%20emotional%20moment%2C%20high%20energy&width=800&height=500&seq=article-3-2026-x3&orientation=landscape',
    imagePrompt: 'A young Chinese singer performing on a grand stage with dramatic stage lighting and confetti falling, holding a microphone with passion, large audience cheering in the background, concert photography style, warm spotlight, emotional moment, high energy',
    author: '娱乐记者小李',
    publishedAt: '2026-07-05',
    readTime: 4,
    isHot: true,
    isNew: false,
    tags: ['歌手2026', '林小宇', '总决赛', '综艺', '音乐'],
    views: 189000,
    source: '网易娱乐',
  },
  {
    id: 'article-4',
    title: '明星夫妻赵晨与刘思思官宣离婚，五年婚姻画上句号',
    excerpt: '演员赵晨与模特刘思思通过各自工作室同时发布声明，确认两人已和平分手，将共同抚养孩子。',
    content: `<p>演员赵晨与模特刘思思今日通过各自工作室同时发布声明，确认两人已和平分手，结束了为期五年的婚姻关系。声明中强调双方将共同抚养两个年幼的孩子，并呼吁外界尊重他们的隐私。</p><p>赵晨与刘思思于2021年结婚，婚后育有一子一女。两人曾被誉为娱乐圈"模范夫妻"，经常在社交平台晒出家庭生活的温馨瞬间。近半年来，两人鲜少同框，引发外界猜测。</p><p>娱乐圈婚姻专家分析认为，明星夫妻面临的工作压力、聚少离多等因素是导致婚姻破裂的主要原因。赵晨目前正在横店拍摄新剧，刘思思则在上海经营自己的时尚品牌。</p><p>两人工作室在声明最后表示"感谢大家一直以来的关心与支持，未来将以亲人身份继续守护孩子成长"，并明确表示不再对此事作进一步回应。</p>`,
    category: '明星八卦',
    categorySlug: 'celebrity',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20couple%20walking%20apart%20on%20a%20rainy%20city%20street%20at%20night%2C%20silhouettes%20reflected%20in%20puddles%2C%20melancholic%20mood%2C%20cinematic%20lighting%20with%20neon%20signs%20blurred%20in%20background%2C%20emotional%20artistic%20photography%2C%20cool%20tones%20with%20warm%20accents&width=800&height=500&seq=article-4-2026-x4&orientation=landscape',
    imagePrompt: 'A couple walking apart on a rainy city street at night, silhouettes reflected in puddles, melancholic mood, cinematic lighting with neon signs blurred in background, emotional artistic photography, cool tones with warm accents',
    author: '娱乐记者小周',
    publishedAt: '2026-07-04',
    readTime: 3,
    isHot: false,
    isNew: true,
    tags: ['赵晨', '刘思思', '离婚', '明星夫妻'],
    views: 275000,
    source: '凤凰娱乐',
  },
  {
    id: 'article-5',
    title: '著名导演张海新片《迷雾追踪》路透曝光，豪华阵容引期待',
    excerpt: '张海导演继《深渊》后的又一力作《迷雾追踪》今日曝光片场路透，主演阵容包括影帝陈浩和视后孙雨桐。',
    content: `<p>著名导演张海继获奖作品《深渊》后的又一力作《迷雾追踪》今日曝光片场路透照。该片由影帝陈浩和视后孙雨桐联袂主演，是一部悬疑犯罪题材的电影。</p><p>路透照片显示，影片正在重庆取景拍摄，陈浩在片中饰演一位执着追凶的刑警，孙雨桐则饰演一位关键证人。两人在片场的对手戏被现场工作人员形容为"火花四溅"。</p><p>张海导演近年来作品口碑持续攀升，其上一部作品《深渊》曾获得金鸡奖最佳导演提名。《迷雾追踪》的投资规模据传超过5亿元，是今年备受期待的华语电影之一。</p><p>影片预计将于2026年12月上映，片方表示将于下月发布首款预告片。业内人士预测该片有望冲击年度票房冠军。</p>`,
    category: '影视资讯',
    categorySlug: 'film',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mysterious%20film%20set%20in%20a%20foggy%20Chinese%20city%20with%20actors%20in%20detective%20costumes%2C%20film%20crew%20and%20equipment%20visible%2C%20noir%20atmosphere%2C%20rain-slicked%20streets%2C%20vintage%20car%20parked%20nearby%2C%20cinematic%20behind%20the%20scenes%20photography%2C%20moody%20and%20atmospheric&width=800&height=500&seq=article-5-2026-x5&orientation=landscape',
    imagePrompt: 'A mysterious film set in a foggy Chinese city with actors in detective costumes, film crew and equipment visible, noir atmosphere, rain-slicked streets, vintage car parked nearby, cinematic behind the scenes photography, moody and atmospheric',
    author: '电影记者阿杰',
    publishedAt: '2026-07-04',
    readTime: 4,
    isHot: false,
    isNew: true,
    tags: ['张海', '迷雾追踪', '陈浩', '孙雨桐', '电影'],
    views: 98000,
    source: '豆瓣电影',
  },
  {
    id: 'article-6',
    title: '年度最受欢迎艺人榜单出炉，周雨桐蝉联榜首实至名归',
    excerpt: '由权威娱乐媒体联合发布的2026年度最受欢迎艺人榜单今日揭晓，歌手兼演员周雨桐连续第三年蝉联榜首。',
    content: `<p>由权威娱乐媒体联合发布的2026年度最受欢迎艺人榜单今日正式揭晓。歌手兼演员周雨桐以绝对优势连续第三年蝉联榜首，成为该榜单设立以来首位三连冠艺人。</p><p>榜单评选综合了社交媒体影响力、作品表现、商业价值和公众美誉度等多个维度。周雨桐在过去一年中发行了两张专辑、主演了一部电影，均取得了优异的成绩。</p><p>排名第二至五位的分别是：演员王一凡、歌手刘浩宇、演员孙雨桐和偶像团体"星河少年"成员李星辰。今年的榜单出现了不少新人面孔，反映出娱乐圈代际更迭的趋势。</p><p>周雨桐通过工作室发表感言，感谢粉丝一直以来的支持，并表示将继续努力创作更好的作品回馈大家。</p>`,
    category: '明星八卦',
    categorySlug: 'celebrity',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20glamorous%20award%20ceremony%20stage%20with%20a%20female%20Chinese%20celebrity%20in%20an%20elegant%20gown%20holding%20a%20trophy%2C%20golden%20confetti%20falling%2C%20bright%20stage%20lights%2C%20red%20carpet%20elements%2C%20professional%20event%20photography%2C%20luxurious%20atmosphere%2C%20celebration%20mood&width=800&height=500&seq=article-6-2026-x6&orientation=landscape',
    imagePrompt: 'A glamorous award ceremony stage with a female Chinese celebrity in an elegant gown holding a trophy, golden confetti falling, bright stage lights, red carpet elements, professional event photography, luxurious atmosphere, celebration mood',
    author: '榜单编辑小林',
    publishedAt: '2026-07-03',
    readTime: 3,
    isHot: false,
    isNew: false,
    tags: ['周雨桐', '最受欢迎艺人', '榜单', '年度评选'],
    views: 125000,
    source: '腾讯娱乐',
  },
  {
    id: 'article-7',
    title: '综艺节目《密室逃脱7》回归，全新阵容挑战极限恐怖主题',
    excerpt: '备受期待的推理综艺《密室逃脱》第七季正式官宣回归，本季将采用全明星阵容挑战史上最恐怖的密室主题。',
    content: `<p>备受期待的推理综艺《密室逃脱》第七季今日正式官宣回归。节目组公布了全新的全明星阵容，包括演员王一凡、歌手林小宇、主持人何雅、喜剧演员李开心和新生代偶像赵星辰。</p><p>节目总导演透露，本季将挑战"史上最恐怖"的密室主题，场景设计投入超过2000万元，打造了多个令人毛骨悚然的沉浸式体验空间。每位嘉宾在录制过程中都经历了不同程度的惊吓。</p><p>李开心在发布会上笑称："我以为自己是来搞笑的，结果全程都在尖叫。"而王一凡则表示这是他参加过"最费脑力和胆量"的综艺节目。</p><p>《密室逃脱7》将于7月15日起每周五晚8点在芒果TV独家播出，已经引发网友高度期待。</p>`,
    category: '综艺热点',
    categorySlug: 'variety',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20mysterious%20escape%20room%20set%20with%20dramatic%20lighting%2C%20fog%20effects%2C%20old%20wooden%20furniture%20and%20cobwebs%2C%20actors%20in%20casual%20clothes%20looking%20scared%20and%20searching%20for%20clues%2C%20creepy%20atmosphere%2C%20reality%20show%20production%20style%2C%20suspenseful%20mood&width=800&height=500&seq=article-7-2026-x7&orientation=landscape',
    imagePrompt: 'A dark mysterious escape room set with dramatic lighting, fog effects, old wooden furniture and cobwebs, actors in casual clothes looking scared and searching for clues, creepy atmosphere, reality show production style, suspenseful mood',
    author: '综艺记者小雨',
    publishedAt: '2026-07-03',
    readTime: 4,
    isHot: false,
    isNew: true,
    tags: ['密室逃脱', '综艺', '王一凡', '明星阵容'],
    views: 87000,
    source: '芒果TV',
  },
  {
    id: 'article-8',
    title: '网红美食博主"吃货小红"探店造假被曝光，多家餐厅发表声明',
    excerpt: '拥有500万粉丝的美食博主"吃货小红"被曝探店视频全是剧本拍摄，多次在未实际用餐的情况下发布好评。',
    content: `<p>拥有500万粉丝的美食博主"吃货小红"近日被曝探店视频存在严重造假行为。据知情人士透露，其发布的多个探店视频均为提前写好的剧本，博主本人并未实际用餐，部分视频甚至在餐厅尚未营业时完成拍摄。</p><p>事件发酵后，涉事的多家餐厅纷纷发表声明撇清关系。其中位于北京的某火锅店表示："我们从未与该博主有过任何合作，视频中的菜品并非我店出品。"另一家上海日料店也表示将追究其法律责任。</p><p>"吃货小红"团队至今未作出正式回应，但其账号已设置为私密状态。业内知情人士透露，美食探店领域的造假现象并非个案，许多博主通过虚假内容获取流量和广告收益。</p><p>平台方表示将加强对美食类内容的审核力度，并计划推出探店内容真实性认证机制。</p>`,
    category: '网红动态',
    categorySlug: 'influencer',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20food%20blogger%20setting%20up%20a%20camera%20in%20front%20of%20a%20lavish%20dinner%20table%20in%20an%20empty%20restaurant%2C%20ring%20light%20and%20tripod%20visible%2C%20food%20looking%20staged%20and%20untouched%2C%20behind%20the%20scenes%20of%20content%20creation%2C%20warm%20restaurant%20lighting%2C%20slightly%20artificial%20atmosphere&width=800&height=500&seq=article-8-2026-x8&orientation=landscape',
    imagePrompt: 'A food blogger setting up a camera in front of a lavish dinner table in an empty restaurant, ring light and tripod visible, food looking staged and untouched, behind the scenes of content creation, warm restaurant lighting, slightly artificial atmosphere',
    author: '消费记者大刘',
    publishedAt: '2026-07-02',
    readTime: 4,
    isHot: false,
    isNew: false,
    tags: ['吃货小红', '探店造假', '美食博主', '网红翻车'],
    views: 143000,
    source: '澎湃新闻',
  },
];

export const categories = [
  { name: '明星八卦', slug: 'celebrity', icon: 'ri-star-line', description: '最新明星动态、恋情曝光、娱乐圈内幕' },
  { name: '网红动态', slug: 'influencer', icon: 'ri-live-line', description: '网红直播、博主日常、带货翻车现场' },
  { name: '综艺热点', slug: 'variety', icon: 'ri-tv-line', description: '热门综艺、节目爆料、精彩看点解析' },
  { name: '影视资讯', slug: 'film', icon: 'ri-film-line', description: '新片上映、票房数据、影评剧透' },
];

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.categorySlug === slug);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getLatestArticles(): Article[] {
  return articles.filter((a) => a.isNew);
}

export function getRelatedArticles(currentId: string, categorySlug: string, count: number = 4): Article[] {
  return articles
    .filter((a) => a.id !== currentId && a.categorySlug === categorySlug)
    .slice(0, count);
}

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug);
}